import { useEffect } from "react";

/** Calls `onEscape` while `active`, for dismissing overlays with the Escape key. */
export function useEscapeKey(active: boolean, onEscape: () => void) {
    useEffect(() => {
        if (!active) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onEscape();
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [active, onEscape]);
}
